var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.blockchain ? _c('section', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.blockchain.name) + " Details")])]), _c('Metadata', {
    attrs: {
      "blockchain": _vm.blockchain
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }